<template>
  <div
    ref="triggerRef"
    :class="['bch', { 'bch--disabled': disabled, 'bch--readonly': readonly, 'bch--open': isOpen }]"
    @focusin="focused = true"
    @focusout="focused = false"
  >
    <slot
      name="trigger"
      :isOpen="isOpen"
      :direction="direction"
    />

    <Teleport
      to="body"
      v-if="isOpen && !disabled"
    >
      <div
        ref="layerRef"
        class="bch__layer"
        :style="overlayStyle"
      >
        <slot
          name="content"
          :close
          :isOpen
          :direction
        />
      </div>
    </Teleport>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue'
  import { useFloatingLayer, type FloatingOptions } from './useFloatingLayer.types'

  const props = withDefaults(
    defineProps<{
      disabled?: boolean
      readonly?: boolean
      options?: FloatingOptions
    }>(),
    { disabled: false, readonly: false, options: () => ({}) },
  )

  const isOpen = defineModel<boolean>('isOpen', { default: false })

  const focused = ref(false)
  const triggerRef = ref<HTMLElement | null>(null)
  const layerRef = ref<HTMLElement | null>(null)

  const { direction, overlayStyle, close } = useFloatingLayer(isOpen, triggerRef, layerRef, props.options)
</script>

<style scoped lang="less">
  .bch {
    position: relative;
    display: inline-flex;
    width: 100%;
  }
  .bch__layer {
    position: fixed;
    will-change: top, left, width, height;
  }
</style>
